module.exports = __webpack_public_path__ + "static/media/interier.f17692c3.jpg";